import { render, staticRenderFns } from "./questionOptionModal.vue?vue&type=template&id=f778a020&scoped=true"
import script from "./questionOptionModal.vue?vue&type=script&lang=js"
export * from "./questionOptionModal.vue?vue&type=script&lang=js"
import style0 from "./questionOptionModal.vue?vue&type=style&index=0&id=f778a020&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f778a020",
  null
  
)

export default component.exports